import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class MeasurementUnitService extends GenericService {
  constructor() {
    super('/measurement_units', axiosInstance);
  }
}

export default new MeasurementUnitService(); 